import React, { useEffect, useState } from "react";
import moment from "moment";
import { Tabs, Tab, Form } from "react-bootstrap";
import store from "../../store/Store";
import { dispatcher } from "../../store/storeHelpers";
import * as actionTypes from "../../store/ActionTypes";
import {
	getDailyContainerPlanningAB,
	getReasonsForErrorInShipmentBooking,
	getTractorSIDoc,
	getWeeklyPlan,
	getCarrierMasterDropDown,
	getDailyContainerPlanningCarrier 
} from "../../services/tractorDataService";
import {
	COUNTRY_WISE_WEEKLY_PLAN,
	MARKET_WISE_WEEKLY_PLAN,
} from "../columns/tractorBookingColumns";
import { tractorDataCreatorForStore } from "../../utils/dataFilter";
import CreateNewSchedule from "../common/CreateNewSchedule";
import MonthlyPlanViewer from "../common/MonthlyPlanViewer";
import DailyDashboardPlanViewer from "../common/DailyDashboardPlanViewer";
import BasicDataTable from "../common/BasicDataTable";
import UploadTractorPlan from "../common/upload-new-data/UploadTractorPlan";
import Counters from "../common/Counters";
import TractorTable from "../common/tables/TractorTable";
import { exportData } from "../../utils/helpers";
import TractorActionCenter from "../common/action-center/TractorActionCenter";
import SIDocCard from "../common/SIDocCard";
import { ceil, chunk, filter, includes } from "lodash";
import TractorDailyPlan from "../../assets/ExcelData/TractorDailyPlan.json";
import noDataAvailable from "../../assets/img/noDataAvailable.png";
import Tooltips from "../Custom Components/tooltip";
import { PulseLoader } from "react-spinners";
import MainSIPaginationAdv from "../common/tables/MainSIPaginationAdv";
import { getTransporterList } from "../../services/dataService";
import { uniqBy } from "lodash";

function TractorBooking() {

const [selectedFilter, setSelectedFilter] = useState("");
const [carriers, setCarriers] = useState([]);
const [filterOptions, setFilterOptions] = useState([
	{ label: "All", value: "" },
  { label: "5D", value: "5D" },
  { label: "5E", value: "5E" },
  { label: "3D", value: "3D" },
  { label: "Chassis", value: "Chassis" },
]);

  const [carrierOptions, setCarrierOptions] = useState([]);
  const [carrierFilter, setCarrierFilter] = useState("");
  const [selectedCarrier, setSelectedCarrier] = useState("");
 const [selectedTradeLane, setSelectedTradeLane] = useState("");

const tradeLaneOptions = [
  { label: "All", value: "" },
  { label: "Asia-Europe", value: "Asia-Europe" },
  { label: "Asia-MiddleEast", value: "Asia-MiddleEast" },
  { label: "Asia-Africa", value: "Asia-Africa" },
  { label: "Asia-NorthAmerica", value: "Asia-NorthAmerica" },
  { label: "Asia-SouthAmerica", value: "Asia-SouthAmerica" },
];





// const carrierOptions = [
//   { label: "All", value: "" },
//   { label: "Maersk", value: "Maersk" },
//   { label: "MSC", value: "MSC" },
//   { label: "CMA CGM", value: "CMA CGM" },
//   { label: "Hapag-Lloyd", value: "Hapag-Lloyd" },
// ];

	const [loader, setLoader] = useState(false);
	const [data, setData] = useState([]);
	const [date, setDate] = useState(
		moment().add(1, "days").format("YYYY-MM-DD")
	);
	const [type, setType] = useState(localStorage.getItem("tractor-tab-key"));
	const [reasons, setReasons] = useState();
	const [showCreateNewSchedule, setShowCreateNewSchedule] = useState(false);
	const [showDailyPlanUploader, setShowDailyPlanUploader] = useState(false);
	const [monthlyData, setMonthlyData] = useState({});
	const [selectedDate, setSelectedDate] = useState(moment());
	const [selectedMonth, setSelectedMonth] = useState(selectedDate);
	const [weeklyCountryWiseData, setWeeklyCountryWiseData] = useState([]);
	const [weeklyMarketWiseData, setWeeklyMarketWiseData] = useState([]);
	// const [counter, setCounter] = useState({
	// 	Booked: 0,
	// 	Pending: 0,
	// 	Approved: 0,
	// 	Cancelled: 0,
	// 	Not_Booked: 0,
	// });
	const [siDocDate, setSIDocDate] = useState(
		moment().add(1, "days").format("YYYY-MM-DD")
	);
	const [originalSIDocList, setOriginalSIDocList] = useState([]);
	const [pageIndex, setPageIndex] = useState(0);
	const [allSIData, setAllSIData] = useState([]);
	const [searchedSIData, setSearchedSIData] = useState([]);
	const [searchText, setSearchText] = useState("");
	const [searchFilteredData, setSearchFilteredData] = useState([]);
	
	const [newSelectedFlatRows, setNewSelectedFlatRows] = useState([]);

	const [userData, setUserData] = useState([]);
	const [filteredUserAccessData, setFilteredUserAccessData] = useState([]);
	const [noDataState, setNoDataState] = useState(false);
	const [SIPageSize, setSIPageSize] = useState(14);
	const [countData, setCountData] = useState({
		label : [],
		counterData : {
			Booked: 0,
			Pending: 0,
			Approved: 0,
			Cancelled: 0,
			Not_Booked: 0,
		}
	})
	const [transporterList, setTransporterList] = useState("");

	// useEffect(() => {
	// 	setCounter(getCount(data));
	// }, [data]);

	useEffect(() => {
		const unsubscribe = store.subscribe(() => {
			setData(Object.values(store.getState().daily_tractor_bookings));
			setUserData(Object.values(store.getState().userAccessData));
		});
		return () => {
			unsubscribe();
		};
	});

	useEffect(() => {
		setUserData(Object.values(store.getState().userAccessData));
	}, [setUserData]);

	useEffect(() => {
		if (filter(userData, { MenuName: "Tractor", View: 1 }).length > 0) {
			setFilteredUserAccessData(
				filter(userData, { MenuName: "Tractor", View: 1 })
			);
		}
	}, [userData]);

	useEffect(() => {
		let mounted = true;
		async function getDropdownOptions() {
			try {
				if (type === "Daily") {
					const reasonList = await getReasonsForErrorInShipmentBooking();
					if (mounted) {
						setReasons(reasonList.data);
					}
				}
			} catch (error) {}
		}
		if (!reasons) {
			getDropdownOptions();
		}
		return () => {
			mounted = false;
		};
	}, [reasons, type]);

	const resetStorage = () => {
		setData([]);
		setWeeklyMarketWiseData([]);
		setWeeklyCountryWiseData([]);
		setMonthlyData({});
	};

	useEffect(() => {
		let mounted = true;
		let counterLabel = []
		let counterValue = {
			Booked: 0,
			Pending: 0,
			Approved: 0,
			Cancelled: 0,
			Not_Booked: 0,
			Hold:0,
		}
		async function getPlan() {
			resetStorage();
			setLoader(true);
			try {
				setNoDataState(false);
				if (type === "Daily") {
					const response = await getDailyContainerPlanningAB(
						moment(date).format("YYYY-MM-DD")
					);
					if (mounted) {
						dispatcher(
							actionTypes.TRACTOR_BOOKING_LOADED,
							tractorDataCreatorForStore(response.data.Resultset1)
						);
					}
					for (let i = 0; i < response.data.Resultset2.length; i++) {
						counterLabel.push(response.data.Resultset2[i]["STATUS"])
						if(response.data.Resultset2[i]["STATUS"] === "Booked"){
							counterValue.Booked = response.data.Resultset2[i]["Container_Count"]
						}
						if(response.data.Resultset2[i]["STATUS"] === "Not_Booked"){
							counterValue.Not_Booked = response.data.Resultset2[i]["Container_Count"]
						}
						if(response.data.Resultset2[i]["STATUS"] === "Pending"){
							counterValue.Pending = response.data.Resultset2[i]["Container_Count"]
						}
						if(response.data.Resultset2[i]["STATUS"] === "Approved"){
							counterValue.Approved = response.data.Resultset2[i]["Container_Count"]
						}
						if(response.data.Resultset2[i]["STATUS"] === "Cancelled"){
							counterValue.Cancelled = response.data.Resultset2[i]["Container_Count"]
						}
						if(response.data.Resultset2[i]["STATUS"] === "Hold"){
							counterValue.Hold = response.data.Resultset2[i]["Container_Count"]
						}
					}
					setCountData({label : counterLabel, counterData : counterValue})
					
				} else if (type === "Weekly") {
					const countryResp = await getWeeklyPlan(
						moment(date).format("MMM-YY"),
						"Country"
					);
					const marketResp = await getWeeklyPlan(
						moment(date).format("MMM-YY"),
						"Market"
					);
					if (mounted) {
						setWeeklyCountryWiseData(countryResp.data);
						setWeeklyMarketWiseData(marketResp.data);
					}
				}
				setLoader(false);
			} catch (error) {
				setLoader(false);
				if (error.response.data.StatusCode === 404) {
					setNoDataState(true);
					setCountData({
						label : [],
						counterData : {
							Booked: 0,
							Pending: 0,
							Approved: 0,
							Cancelled: 0,
							Not_Booked: 0,
							Hold:0,
						}
					})
				}
			}
		}
		getPlan();
		return () => (mounted = false);
	}, [date, type, selectedMonth, setCountData]);

	useEffect(() => {
    async function getTransporterData() {
      if (type === "Daily") {
        try {
          const response = await getTransporterList();
          const uniqContainerCountData = uniqBy(
            response.data,
            "TransporterName"
          );
          setTransporterList(uniqContainerCountData);
        } catch (error) {}
      }
    }
    getTransporterData();
  }, [type]);

	useEffect(() => {
    if (type === "SI") {
      if (!searchText) {
        const dataSetter = (data) => {
          setOriginalSIDocList(data);
          setSearchedSIData(chunk(data, 14)[pageIndex]);
        };
        const getDocs = async () => {
          try {
            setLoader(true);
            setNoDataState(false);
            const response = await getTractorSIDoc(siDocDate);
            dataSetter(response.data);
            setAllSIData(response.data);
            setLoader(false);
          } catch (error) {
            if (error.response && error.response.status === 404) {
              dataSetter([]);
              setNoDataState(true);
              setLoader(false);
            }
          }
        };
        getDocs();
      } else {
        setOriginalSIDocList(searchFilteredData);
        setSearchedSIData(chunk(searchFilteredData, SIPageSize)[pageIndex]);
      }
    }
  }, [siDocDate, pageIndex, searchText, searchFilteredData, SIPageSize, type]);

	useEffect(() => {
		setSearchedSIData(chunk(originalSIDocList, SIPageSize)[pageIndex]);
	}, [pageIndex, originalSIDocList, SIPageSize]);
  useEffect(() => {
    fetchCarriers();
  }, []);

  const fetchCarriers = async () => {
    try {
      const response = await getCarrierMasterDropDown();
      if (response && Array.isArray(response.data)) {
        setCarriers(response.data);
      }
    } catch (error) {
      console.error("Error fetching carrier list:", error);
    }
  };
const handleCarrierChange = async (e) => {
  const carrier = e.target.value;
  setSelectedCarrier(carrier);

  const formattedMonth = moment(selectedMonth).format("MMM-YY");

  try {
    const response = await getDailyContainerPlanningCarrier(formattedMonth, carrier);
 
    // ✅ Store to Redux
    dispatcher({
      type: actionTypes.SET_CARRIER_DASHBOARD_DATA,
      payload: response.data,
    });

	
    // Optional: Navigate or trigger view update
    // navigate or set local state if needed

  } catch (error) {
    console.error("API error:", error);
  }
};



	const dataExportHandler = () => {
		if (type === "Daily") {
			var finalExportData = [];
			for (let i = 0; i < data.length; i++) {
				for (let j = 0; j < data[i].subRows.length; j++) {
					if (
						!includes(finalExportData, {
							DailyContainerPlanningId:
								data[i].subRows[j].DailyContainerPlanningId,
						})
					) {
						finalExportData.push(data[i].subRows[j]);
					}
				}
			}
			exportData(
				finalExportData.map((item) => {
					return {
						OFP_PLAN_DATE: item["Date"],
						MARKET: item["Market"],
						VARIANT: item["Varient_PartNumber"],
						TRANSPORTER: item["Transporter"],
						QUANTITY: item["Quantity"],
						COUNTRY: item["Country"],
						PORT_OF_DESTINATION: item["Port_Of_Destination"],
						CONTAINER_COUNT: item["Container_Count"],
						CONTAINER_TYPE: item["Container_Type"],
						INSPECTION: item["Inspection"],
						SI: item["SI"],
						REMARK: item["Remark"],
						BOOKING_NUMBER: item["Booking_Number"],
						BOOKING_DOC: item["BookingDocument"],
						REASON: item["Reason"],
						STATUS: item["STATUS"],
						VSL_VOY: item["VSL_VOY"],
						FINAL_DESTINATION: item["final_destination"],
						ETD: item["ETD"] === "Invalid date" ? "" : moment(item["ETD"]).format("DD-MM-YYYY"),
						ETA: item["ETA"] === "Invalid date" ? "" : moment(item["ETA"]).format("DD-MM-YYYY"),
						CARRIER: item["Carrier"],
						JD_STUFFING_DATE:
							item["JD_Stuffing_Date"] === "Invalid date"
								? ""
								: moment(item["JD_Stuffing_Date"]).format("DD-MM-YYYY"),
						GROUND_RENT_DAYS: item["Ground_Rent_Days"],
						ORIGIN_TRANSIT_TIME: item["Origin_Transit_Time"],
						APPROX_CONTAINER_DETENSION: item["Approx_container_detention"],
					};
				}),
				`Tractor_daily_plan${date}`
			);
		} else if (type === "Weekly") {
			exportData(
				weeklyCountryWiseData,
				`Tractor_weekly_country_wise_plan${moment(date).format("MMM-YYYY")}`
			);
			exportData(
				weeklyMarketWiseData,
				`Tractor_weekly_market_wise_plan${moment(date).format("MMM-YYYY")}`
			);
		} else if (type === "Monthly") {
			exportData(
				monthlyData,
				`Tractor_monthly_plan${moment(date).format("MMM-YYYY")}`
			);
		}
	};

	const tractorTemplateFileExportHandler = () => {
		exportData(
			TractorDailyPlan,
			`Tractor Daily Plan Excel Template ${moment(date).format("DD-MM-YYYY")}`
		);
	};

	function changeHandler(e) {
		setSearchText(e.target.value);
		if (e.target.value.length > 1) {
			let docList = [];
			for (const doc of allSIData) {
				if (
					`${doc.DocName}`.toLowerCase().includes(e.target.value.toLowerCase())
				) {
					docList.push(doc);
				}
			}
			setSearchFilteredData(docList);
			setSearchedSIData(chunk(docList, SIPageSize)[pageIndex]);
		} else {
			setSearchedSIData(chunk(allSIData, SIPageSize)[pageIndex]);
		}
	}
	return (
		<>
			<div className="flex-row mb-12 counterHeaderResponsive">
				<h1>Tractor</h1>
				{type === "Daily" && (
					<Counters
						counter={countData.counterData}
						label={countData.label}
						styleData="df_dailyCounter"
					/>
				)}
			</div>
			<CreateNewSchedule
				show={showCreateNewSchedule}
				handleClose={() => setShowCreateNewSchedule(false)}
			/>
			{showDailyPlanUploader && <UploadTractorPlan
				show={showDailyPlanUploader}
				handleClose={() => setShowDailyPlanUploader(false)}
				setNoDataState={setNoDataState}
				siDocDate={siDocDate}
				setSIDocDate={setSIDocDate}
				setOriginalSIDocList={setOriginalSIDocList}
				setSearchedSIData={setSearchedSIData}
				setAllSIData={setAllSIData}
				pageIndex={pageIndex}
				setCountData={setCountData}
				date={date}
				setDate={setDate}
			/>}
			<Tabs
				activeKey={type}
				style={{
					marginBottom: "12px",
					marginTop: "-20px",
				}}
				defaultActiveKey={"Daily"}
				onSelect={(k) => {
					setType(k);
					localStorage.setItem("tractor-tab-key", k);
				}}
			>
				<Tab eventKey="Daily" title="Daily Plan">
					{loader && (
						<PulseLoader
							color="#007bff"
							size="20px"
							margin="10px"
							style={{ position: "relative", top: "40vh", left: "45%" }}
						/>
					)}
					{/* {loader && <Loader />} */}
					{!loader && noDataState && (
						<img
							src={noDataAvailable}
							alt="notAvailableImg"
							className="noDataFoundImg"
							// style={{ marginLeft: "-2%" }}
						/>
					)}
					{!loader && type === "Daily" && (
						<TractorTable
							tableData={data}
							reasons={reasons}
							date={date}
							setDate={setDate}
							setShowCreateNewSchedule={setShowCreateNewSchedule}
							setShowDailyPlanUploader={setShowDailyPlanUploader}
							dataExportHandler={dataExportHandler}
							tractorTemplateFileExportHandler={
								tractorTemplateFileExportHandler
							}
							subModule="Daily"
							type={"Daily"}
							newSelectedFlatRows={newSelectedFlatRows}
							setNewSelectedFlatRows={setNewSelectedFlatRows}
							filteredUserAccessData={filteredUserAccessData}
							noDataState={noDataState}
							setNoDataState={setNoDataState}
							countData={countData}
							setCountData={setCountData}
							transporterList={transporterList}
						/>
					)}
				</Tab>
				<Tab eventKey="Weekly" title="Weekly Plan">
					{loader && (
						<PulseLoader
							color="#007bff"
							size="20px"
							margin="10px"
							style={{ position: "relative", top: "40vh", left: "45%" }}
						/>
					)}
					{!loader && type === "Weekly" && (
						<>
							<div className="table_actions">
								<TractorActionCenter
									date={date}
									setDate={setDate}
									setShowCreateNewSchedule={setShowCreateNewSchedule}
									setShowDailyPlanUploader={setShowDailyPlanUploader}
									dataExportHandler={dataExportHandler}
									subModule="Weekly"
									newSelectedFlatRows={newSelectedFlatRows}
									setNewSelectedFlatRows={setNewSelectedFlatRows}
									filteredUserAccessData={filteredUserAccessData}
									setNoDataState={setNoDataState}
								/>
							</div>
							<BasicDataTable
								columns={COUNTRY_WISE_WEEKLY_PLAN}
								data={weeklyCountryWiseData}
								customPageSize={4}
							/>
							<BasicDataTable
								columns={MARKET_WISE_WEEKLY_PLAN}
								data={weeklyMarketWiseData}
								customPageSize={4}
							/>
						</>
					)}
				</Tab>
				<Tab eventKey="Monthly" title="Monthly Plan">
					{loader && (
						<PulseLoader
							color="#007bff"
							size="20px"
							margin="10px"
							style={{ position: "relative", top: "40vh", left: "45%" }}
						/>
					)}
					{!loader && type === "Monthly" &&  (
						<>
							<div className="table_actions" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
								{/* Filter dropdown */}
								<div style={{ display: "flex", alignItems: "center" }}>
<select
  id="regionFilter"
  name="region"
  value={selectedFilter}
  onChange={(e) => setSelectedFilter(e.target.value)}
  style={{
    padding: "10px 14px",
    borderRadius: "8px",
    border: "1px solid #c2e0ff",
    outline: "none",
    boxShadow: "0 0 6px rgba(0, 140, 255, 0.15)",
    backgroundColor: "#f9fcff",
    fontSize: "14px",
    color: "#333",
    fontWeight: "400",
    minWidth: "160px",
    transition: "all 0.2s ease",
    marginRight: "10px",
  }}
>
  <option value="" disabled hidden>
    Select Region
  </option>
  {filterOptions.map((opt) => (
    <option key={opt.value} value={opt.value}>
      {opt.label}
    </option>
  ))}
</select>




								</div>
	
								<TractorActionCenter
									date={date}
									setDate={setDate}
									setShowCreateNewSchedule={setShowCreateNewSchedule}
									setShowDailyPlanUploader={setShowDailyPlanUploader}
									dataExportHandler={dataExportHandler}
									type={"month"}
									subModule="Monthly"
									selectedMonth={selectedMonth}
									newSelectedFlatRows={newSelectedFlatRows}
									setNewSelectedFlatRows={setNewSelectedFlatRows}
									monthlyData={monthlyData}
									filteredUserAccessData={filteredUserAccessData}
									setNoDataState={setNoDataState}
								/>
							</div>
							<MonthlyPlanViewer
								setSelectedDate={setSelectedDate}
								monthlyData={monthlyData}
								selectedDate={selectedDate}
								selectedMonth={selectedMonth}
								setSelectedMonth={setSelectedMonth}
								firstKey={"Market"}
								secondKey={"Country"}
								dataType="Tractor"
								setMonthlyData={setMonthlyData}
								selectedFilter={selectedFilter}   
							/>
						</>
					)}
				</Tab>
				
<Tab eventKey="Daily Dashboard" title="Daily Dashboard">
  {loader ? (
    <PulseLoader
      color="#007bff"
      size="20px"
      margin="10px"
      style={{ position: "relative", top: "40vh", left: "45%" }}
    />
  ) : (
    <>
      <div
        className="table_actions"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
  <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
  {/* Region Filter */}
  <select
    id="regionFilter"
    name="region"
    value={selectedFilter}
    onChange={(e) => setSelectedFilter(e.target.value)}
    style={{
      padding: "10px 14px",
      borderRadius: "8px",
      border: "1px solid #c2e0ff",
      outline: "none",
      boxShadow: "0 0 6px rgba(0, 140, 255, 0.15)",
      backgroundColor: "#f9fcff",
      fontSize: "14px",
      color: "#333",
      fontWeight: "400",
      minWidth: "160px",
    }}
  >
    <option value="" disabled hidden>Select Region</option>
    {filterOptions.map((opt) => (
      <option key={opt.value} value={opt.value}>
        {opt.label}
      </option>
    ))}
  </select>

  {/* Trade Lane Filter */}
  <select
    id="tradeLaneDropdown"
    className="form-select"
    style={{
      borderRadius: "12px",
      backgroundColor: "rgb(248, 251, 255)",
      border: "1px solid rgb(201, 209, 217)",
      padding: "6px 12px",
      height: "40px",
      width: "220px",
    }}
    value={selectedTradeLane}
    onChange={(e) => setSelectedTradeLane(e.target.value)}
  >
    <option value="" disabled hidden>Select Trade Lane</option>
    {tradeLaneOptions.map((item, index) => (
      <option key={index} value={item.value}>
        {item.label}
      </option>
    ))}
  </select>

  {/* Carrier Filter */}
  <select
    id="carrierDropdown"
    name="carrier"
    className="form-select"
    style={{
      borderRadius: "12px",
      backgroundColor: "rgb(248, 251, 255)",
      border: "1px solid rgb(201, 209, 217)",
      padding: "6px 12px",
      height: "40px",
      width: "220px"
    }}
    value={selectedCarrier}
    onChange={handleCarrierChange}
  >
    <option value="" disabled hidden>Select Carrier</option>
    <option value="All">All</option>
    {carriers.map((item, index) => (
      <option key={index} value={item.Carrier}>
        {item.Carrier}
      </option>
    ))}
  </select>
</div>


        <Tooltips content={"Download Template"} direction="down">
          <button
            type="button"
            className="tractorActionCenter__upload"
            onClick={() => {}}
          >
            <i className="bx bx-download"></i>
          </button>
        </Tooltips>
      </div>

      <DailyDashboardPlanViewer
        monthlyData={monthlyData}
        selectedDate={selectedDate}
        setSelectedDate={setSelectedDate}
        selectedMonth={selectedMonth}
        setSelectedMonth={setSelectedMonth}
        firstKey={"Market"}
        secondKey={"Country"}
        dataType={selectedCarrier ? "Carrier" : "Tractor"} 
        type={"DailyDashboard"}
        subModule="Daily Dashboard"
        setMonthlyData={setMonthlyData}
        selectedFilter={selectedFilter}
        setSelectedFilter={setSelectedFilter}
		  selectedCarrier={selectedCarrier} 
		    setSelectedCarrier={setSelectedCarrier}
        
      />
    </>
  )}
</Tab>




				
			</Tabs>
		</>
	);
}

export default TractorBooking;
